// Auth
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CERRAR_SESION = "CERRAR_SESION";

// Marcas
export const GET_ALL_MARCAS = "GET_ALL_MARCAS";
export const OBTENER_MARCA = "OBTENER_MARCA";
export const ADD_MARCAS = "ADD_MARCAS";
export const UPDATE_MARCAS = "UPDATE_MARCAS";
export const DELETE_MARCAS = "DELETE_MARCAS";

// Clientes
export const GET_ALL_CLIENTES = "GET_ALL_CLIENTES";
export const OBTENER_CLIENTE = "OBTENER_CLIENTE";
export const ADD_CLIENTES = "ADD_CLIENTES";
export const UPDATE_CLIENTES = "UPDATE_CLIENTES";
export const DELETE_CLIENTES = "DELETE_CLIENTES";

// Tipo Cliente
export const GET_ALL_TIPO_CLIENTES = "GET_ALL_TIPO_CLIENTES";
export const OBTENER_TIPO_CLIENTE = "OBTENER_TIPO_CLIENTE";
export const ADD_TIPO_CLIENTES = "ADD_TIPO_CLIENTES";
export const UPDATE_TIPO_CLIENTES = "UPDATE_TIPO_CLIENTES";
export const DELETE_TIPO_CLIENTES = "DELETE_TIPO_CLIENTES";

// Grupos
export const GET_ALL_GRUPOS = "GET_ALL_GRUPOS";
export const OBTENER_GRUPO = "OBTENER_GRUPO";
export const ADD_GRUPOS = "ADD_GRUPOS";
export const UPDATE_GRUPOS = "UPDATE_GRUPOS";
export const DELETE_GRUPOS = "DELETE_GRUPOS";

// Regionales
export const GET_ALL_REGIONALES = "GET_ALL_REGIONALES";
export const OBTENER_REGIONAL = "OBTENER_REGIONAL";
export const ADD_REGIONALES = "ADD_REGIONALES";
export const UPDATE_REGIONALES = "UPDATE_REGIONALES";
export const DELETE_REGIONALES = "DELETE_REGIONALES";

// Modelos
export const GET_ALL_MODELOS = "GET_ALL_MODELOS";
export const OBTENER_MODELO = "OBTENER_MODELO";
export const ADD_MODELOS = "ADD_MODELOS";
export const UPDATE_MODELOS = "UPDATE_MODELOS";
export const DELETE_MODELOS = "DELETE_MODELOS";

// Contactos
export const GET_ALL_CONTACTOS = "GET_ALL_CONTACTOS";
export const OBTENER_CONTACTO = "OBTENER_CONTACTO";
export const ADD_CONTACTOS = "ADD_CONTACTOS";
export const UPDATE_CONTACTOS = "UPDATE_CONTACTOS";
export const DELETE_CONTACTOS = "DELETE_CONTACTOS";

//Puestos
export const GET_ALL_PUESTOS = "GET_ALL_PUESTOS";
export const OBTENER_PUESTO = "OBTENER_PUESTO";
export const ADD_PUESTOS = "ADD_PUESTOS";
export const UPDATE_PUESTOS = "UPDATE_PUESTOS";
export const DELETE_PUESTOS = "DELETE_PUESTOS";

//Departamentos
export const GET_ALL_DEPARTAMENTOS = "GET_ALL_DEPARTAMENTOS";
export const OBTENER_DEPARTAMENTO = "OBTENER_DEPARTAMENTO";
export const ADD_DEPARTAMENTOS = "ADD_DEPARTAMENTOS";
export const UPDATE_DEPARTAMENTOS = "UPDATE_DEPARTAMENTOS";
export const DELETE_DEPARTAMENTOS = "DELETE_DEPARTAMENTOS";

// Usuarios
export const GET_ALL_USERS = "GET_ALL_USERS";
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const ADD_USUARIOS = "ADD_USUARIOS";
export const UPDATE_USUARIOS = "UPDATE_USUARIOS";
export const DELETE_USUARIOS = "DELETE_USUARIOS";
export const ASIGNAR_TIPO_CLIENTE = "ASIGNAR_TIPO_CLIENTE";

// Regimenes Fiscales
export const GET_ALL_REGIMENES_FISCALES = "GET_ALL_REGIMENES_FISCALES";
export const GET_COUNT_TIPO_CLIENTES = "GET_COUNT_TIPO_CLIENTES";
